import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';

import Header from '../Header/Header';
// import Modal from '../Modal/Modal';
// import ModalContent from '../ModalContent/ModalContent';
import { DetailPanelProvider } from '../../utils/DetailPanelContext';
import styles from  './DbPageLayout.module.scss';

const DbPageLayout = ({children, location, modalContent, seoData}, props) => {

  // const [showModal, setModalOpen] = React.useState(false);

  const detailPanel = {
    isPanelPreloaded: false,
    isTooltipPreloaded: false
  };

  // const openDialog = () => {
  //   setModalOpen(true);
  // }

  // const closeDialog = () => {
  //   setModalOpen(false);
  // }

  return (
    <div className={styles.container}>
      <Header location={location} />
      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <Typography variant={'h5'} className={styles.title}>
              {seoData.title}
            </Typography>
          </div>
        </div>

        <DetailPanelProvider value={detailPanel}>
          {children}
        </DetailPanelProvider>

      </div>
    </div>
  )
}

DbPageLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default DbPageLayout
